import React, { forwardRef, ReactNode } from 'react'
import { StyleScrollWrapper } from './style'

interface ScrollViewProps {
  children: ReactNode
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const ScrollView = forwardRef<HTMLDivElement, ScrollViewProps>(
  ({ children, ...restProps }, ref) => {
    return (
      <StyleScrollWrapper ref={ref} {...restProps}>
        {children}
      </StyleScrollWrapper>
    )
  },
)

export default ScrollView
